// extracted by mini-css-extract-plugin
export var container = "_5p-1";
export var cornerButtonContainer = "_5p-5";
export var disabled = "_5p-2";
export var fileContainer = "_5p-4";
export var hiddenInput = "_5p-3";
export var widthContainer = "_5p-0";